<div class="animate__animated animate__fadeInRight">
    <br />

    <div class="col">
      <mat-card class="mat_card_general p-5">
        <h1 class>Modulo de Equipos Tecnológicos</h1>
      </mat-card>
    </div>

    <br />
    <mat-card class="mat-elevation-z0 mat_card_general_content">
      <app-agregar-equipos-tecnologicos
        #agregarComp
        (onDebounce)="actualizarTabla($event)"
      ></app-agregar-equipos-tecnologicos>
      <br />
      <app-lista-equipos-tecnologicos
        (onDebounce)="actualizarTabla($event)"
        (editar)="agregarComp.abrirEdicion($event)"
        [equipos_List]="equipos"
      ></app-lista-equipos-tecnologicos>
    </mat-card>
    <hr />
  </div>
